import React from "react";
import {Drawer, Form, Button, Col, Row, Input, AutoComplete, DatePicker, InputNumber} from 'antd';
import {createItem, updateItem} from "../../Store/Actions/item";


class Item extends React.Component {

    state = {
        loading: false,
        image: "https://bavariancarcare.com/wp-content/uploads/2019/12/image-placeholder-1200x800-1.jpg"
    }

    onChange = values => {
        if(values.price && values.price.value) {
            this.setState({
                value: values.price.value
            })
        } else if(values.price && values.price.per) {
            this.setState({
                per: values.price.per
            })
        } else {
            this.setState({
                ...values
            })
        }

    }

    createKeywords = name => {
        const arrName = [];
        let curName = '';
        name.toLowerCase().split('').forEach(letter => {
            curName += letter;
            arrName.push(curName);
        });
        return arrName;
    }


    generateKeywords = values => {
        const { name, category, company } = values;
        const com = company.length > 0 ? ` ${company}` : "";
        const keywordNameCategoryCompany = this.createKeywords(`${name} ${category}${com}`);
        const keywordNameCompanyCategory = this.createKeywords(`${name}${com} ${category}`);
        const keywordCategoryNameCompany = this.createKeywords(`${category} ${name}${com}`);
        const keywordCategoryCompanyName = this.createKeywords(`${category}${com} ${name}`);
        const keywordCompanyNameCategory = this.createKeywords(`${company} ${name} ${category}`);
        const keywordCompanyCategoryName = this.createKeywords(`${company} ${category} ${name}`);

        if(company.length > 0) {
            return [
                ...new Set([
                    '',
                    ...keywordNameCategoryCompany,
                    ...keywordNameCompanyCategory,
                    ...keywordCategoryNameCompany,
                    ...keywordCategoryCompanyName,
                    ...keywordCompanyNameCategory,
                    ...keywordCompanyCategoryName
                ])
            ];
        } else {
            return [
                ...new Set([
                    '',
                    ...keywordNameCategoryCompany,
                    ...keywordCategoryNameCompany
                ])
            ];
        }
    }


    onFinish = values => {
        this.setState({ loading: true })
        const { item, onClose, visible } = this.props;
        values.company = values.company ? values.company : "";

        if(item) {
            let sum = null;
            let count = null;
            if(item.price.sum) {
                sum = values.price.value ? item.price.sum + values.price.value : values.price.value
                count = values.price.value ? item.price.count + 1 : item.price.count;
            } else {
                sum = values.price.value ? values.price.value : null;
                count = values.price.value ? 1 : null;
            }
            updateItem(item.id, {
                ...values,
                keywords: this.generateKeywords(values),
                barcode: values.barcode ? values.barcode : null,
                price: values.price ? {
                    sum: sum,
                    count: count,
                    per: values.price.per ? values.price.per : item.price.per
                } : item.price
            }, res => {
                this.setState({ loading: false })
                onClose();
            })
        } else {
            createItem({
                ...values,
                keywords: this.generateKeywords(values),
                barcode: values.barcode ? values.barcode : null,
                price: values.price ? {
                    sum: values.price.value ? values.price.value : null,
                    count: values.price.value ? 1 : null,
                    per: values.price.per ? values.price.per : null
                } : null
            }, res => {
                this.setState({ loading: false })
                onClose();
            })
        }
    };


    render() {
        const { loading } = this.state;
        const { item, onClose, visible, categories, companies, pers } = this.props;

        return (

            <Drawer
                title={ item ? item.name : "Create new item" }
                width={720}
                onClose={onClose}
                visible={visible}
                bodyStyle={{ paddingBottom: 80 }}
            >

                { item ?
                    <div>
                        <div className="uk-padding-small uk-background-muted uk-border-rounded uk-margin-bottom">
                            <Row gutter={[16, 16]}>
                                <Col span={6}>
                                    <div>
                                        <img src={item.image} className="uk-height-small uk-width-small uk-border-rounded"/>
                                    </div>
                                </Col>
                                <Col span={18}>
                                    <div>
                                        <div>
                                            <h4 className="uk-h4 uk-margin-remove">
                                                { item.name }
                                            </h4>
                                            <p className="uk-p">
                                                <span className="uk-text-muted uk-text-bold">Category: </span>
                                                <span className="uk-text-emphasis">{ item.category }</span>
                                                <br/>
                                                <span className="uk-text-muted uk-text-bold">Producer: </span>
                                                <span className="uk-text-emphasis">{ item.company }</span>
                                                <br/>
                                                <span className="uk-text-muted uk-text-bold">Barcode: </span>
                                                <span className="uk-text-emphasis">{ item.barcode }</span>
                                            </p>
                                            <div>
                                                <h4 className="uk-h4 uk-margin-remove">
                                                    { item.price.sum ? `${parseInt(item.price.sum / item.price.count)}₸` : "Not defined" }
                                                    { item.price.per ? ` / ${item.price.per}` : null }
                                                </h4>
                                                <p className="uk-text-small uk-margin-remove">
                                                    { item.price ? item.price.count : "0" } times
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <Form initialValues={item} layout="vertical" onFinish={this.onFinish}>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item
                                        name="name"
                                        label="Name"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Input.TextArea autoSize={{ maxRows: 3 }} placeholder="Item name" />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="image"
                                        label="Image URL"
                                    >
                                        <Input.TextArea autoSize={{ maxRows: 3 }} placeholder="Image URL" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={8}>
                                <Col span={12}>
                                    <Form.Item
                                        name="category"
                                        label="Category"
                                    >
                                        <AutoComplete
                                            options={categories}
                                            filterOption={(inputValue, option) =>
                                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                            placeholder="Category"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="company"
                                        label="Company"
                                    >
                                        <AutoComplete
                                            options={companies}
                                            filterOption={(inputValue, option) =>
                                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                            placeholder="Producer company"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={8}>
                                <Col>
                                    <Form.Item
                                        name={["price", "value"]}
                                        label="Price"
                                        initialValue={item.price ? item.price.sum / item.price.count : 0}
                                        rules={[
                                            {
                                                type: 'number',
                                                min: 0
                                            },
                                        ]}
                                    >
                                        <InputNumber placeholder="Price" />
                                    </Form.Item>
                                </Col>

                                <Col flex="auto">
                                    <Form.Item
                                        name={["price", "per"]}
                                        label="Price per"
                                    >
                                        <AutoComplete
                                            options={pers}
                                            filterOption={(inputValue, option) =>
                                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                            }
                                            placeholder="Price per ..."
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item
                                        name="barcode"
                                        label="Bar code"
                                    >
                                        <Input placeholder="Bar code" />
                                    </Form.Item>
                                </Col>
                            </Row>


                            <Form.Item>
                                <Button disabled={loading} loading={loading} size="large" type="primary" htmlType="submit">
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                :
                    <Form onValuesChange={this.onChange} layout="vertical" hideRequiredMark onFinish={this.onFinish}>
                        <div className="uk-padding-small uk-background-muted uk-border-rounded uk-margin-bottom">
                            <Row gutter={[16, 16]}>
                                <Col span={6}>
                                    <div>
                                        <img src={this.state.image} className="uk-height-small uk-width-small uk-border-rounded"/>
                                    </div>
                                </Col>
                                <Col span={18}>
                                    <div>
                                        <div>
                                            <h4 className="uk-h4 uk-margin-remove">
                                                { this.state.name }
                                            </h4>
                                            <p className="uk-p">
                                                <span className="uk-text-muted uk-text-bold">Category: </span>
                                                <span className="uk-text-emphasis">{ this.state.category }</span>
                                                <br/>
                                                <span className="uk-text-muted uk-text-bold">Producer: </span>
                                                <span className="uk-text-emphasis">{ this.state.company }</span>
                                                <br/>
                                                <span className="uk-text-muted uk-text-bold">Barcode: </span>
                                                <span className="uk-text-emphasis">{ this.state.barcode }</span>
                                            </p>
                                            <div>
                                                <h4 className="uk-h4 uk-margin-remove">
                                                    { this.state.value ? `${this.state.value}₸` : "Not defined" }
                                                    { this.state.per ? ` / ${this.state.per}` : null }
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <Row gutter={8}>
                            <Col span={12}>
                                <Form.Item
                                    name="name"
                                    label="Name"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Input.TextArea autoSize={{ maxRows: 3 }} placeholder="Item name" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="image"
                                    label="Image URL"
                                >
                                    <Input.TextArea autoSize={{ maxRows: 3 }} placeholder="Image URL" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Col span={12}>
                                <Form.Item
                                    name="category"
                                    label="Category"
                                >
                                    <AutoComplete
                                        options={categories}
                                        filterOption={(inputValue, option) =>
                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        placeholder="Category"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="company"
                                    label="Company"
                                >
                                    <AutoComplete
                                        options={companies}
                                        filterOption={(inputValue, option) =>
                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        placeholder="Producer company"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={8}>
                            <Form.Item
                                name={["price", "value"]}
                                label="Price"
                                rules={[
                                    {
                                        type: 'number',
                                        min: 0
                                    },
                                ]}
                            >
                                <InputNumber placeholder="Price" />
                            </Form.Item>
                            <Col flex="auto">
                                <Form.Item
                                    name={["price", "per"]}
                                    label="Price per"
                                >
                                    <AutoComplete
                                        options={pers}
                                        filterOption={(inputValue, option) =>
                                            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        }
                                        placeholder="Price per ..."
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name="barcode"
                                    label="Bar code"
                                >
                                    <Input placeholder="Bar code" />
                                </Form.Item>
                            </Col>
                        </Row>







                        <Form.Item>
                            <Button disabled={loading} loading={loading} size="large" type="primary" htmlType="submit">
                                <span className="uk-text-bold">
                                    Submit
                                </span>
                            </Button>
                        </Form.Item>
                    </Form>
                }


            </Drawer>
        );
    }


};


export default Item;



// WEBPACK FOOTER //
// ./src/Components/Items/Item.js